import NavBar from "../components/navBar";
import Footer from "../components/footer";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import LinkComponent from "../components/link";
import { useCart } from "../components/cart/cartProvider";

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const REACT_APP_BACKEND_API_KEY = process.env.REACT_APP_BACKEND_API_KEY;

function PaymentSection() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search); 
    const order_id = queryParams.get("order_id");
    const [orderData, setOrderData] = useState(null);
    const getOrder = async (order_id) => {
        try {
            const response = await fetch(`${REACT_APP_BACKEND_URL}get-order/${order_id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "x-api-key": REACT_APP_BACKEND_API_KEY,
            },
            });
        
            const responseData = await response.json();

            if (response.ok) {
                console.log("Payment confirmed:", responseData);
                setOrderData(responseData)
            } else {
                console.error("Error:", responseData);
                return {
                    customer_email: "",
                    shipping_address: "",
                    phone_number: "",
                    delivery_date: "",
                    order_date: ""
                };
            }
        } catch (error) {
            console.error("Request failed:", error);
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US');
    };

    useEffect(() => {
        if (order_id) {
            getOrder(order_id);
        }
    }, [order_id]);

    // If orderData is null, show loading message
    if (!orderData) {
        return (
            <div className="container align-items-center d-flex flex-column mt-5" style={{ height: "90vh" }}>
                <p>Loading...</p>
            </div>
        );
    }
    return (
        <div className="container align-items-center d-flex flex-column my-5" style={{ height: "90vh" }}>
            <div className="container-fluid rounded-5 bg-light">
                <p className="mt-3 ms-3 mb-0" style={{textAlign: "start", fontSize: "clamp(2em, 2vw, 3em)"}}>Payment Confirmed</p>
                <p className="mb-3 ms-3 mt-0" style={{textAlign: "start", fontSize: "clamp(0.5em, 3vw, 1em)"}}>
                    A copy of your receipt and confirmation number will be emailed to you shortly!
                </p>
                <div className="container mx-auto rounded-3 bg-secondary-subtle mt-4" style={{width: "90%", fontSize: "clamp(1em, 3vw, 2em)"}}>
                    <p className="pt-2 mb-2" style={{fontSize: "clamp(1.5em, 2vw, 2em)"}}>Details:</p>
                    <div className="d-flex flex-row mt-0">
                        <p className="me-auto">Order Date:</p>
                        <p>{formatDate(orderData.order_date)}</p>
                    </div>
                    <div className="d-flex flex-row mt-0">
                        <p className="me-auto">Delivery/Pickup Date:</p>
                        <p>{formatDate(orderData.delivery_date)}</p>
                    </div>
                    <div className="d-flex flex-row mt-0">
                        <p className="me-auto">Email:</p>
                        <p>{orderData.customer_email}</p>
                    </div>
                    <div className="d-flex flex-row mt-0">
                        <p className="me-auto">Confirmation #:</p>
                        <p>{order_id}</p>
                    </div>
                    <div className="d-flex flex-row border-top border-dark mt-3 pt-3">
                        <p className="me-auto">Total amount:</p>
                        <p>$ {(orderData.total_amount/100).toFixed(2) || "N/A" }</p>
                    </div>
                </div>
                <div className="d-flex justify-content-center">
                    <LinkComponent link={"/"} component={
                        <button className="btn btn-primary mx-auto my-4">SweetWoodFlora</button>
                    }/>
                </div>
            </div>
        </div>
    );
}

function PaymentConfirmation() {
    return (
        <div>
            <NavBar />
            <PaymentSection />
            <Footer />
        </div>
    );
}

export default PaymentConfirmation;